export const validatePersonalCode = (personalCode: string) => {
  const multiplier1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
  const multiplier2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];

  const control = parseInt(personalCode.charAt(10), 10);

  const calculateMod = (multipliers: number[]) =>
    personalCode
      .slice(0, 10)
      .split('')
      .reduce((sum, char, index) => sum + parseInt(char, 10) * multipliers[index], 0) % 11;

  let mod = calculateMod(multiplier1);

  if (mod === 10) {
    mod = calculateMod(multiplier2);
    if (mod === 10) {
      mod = 0;
    }
  }

  return control === mod;
};
